import React, {useContext, useEffect, useState} from "react";
import {useRouter} from "next/router";
import {request} from "../../shared/httpInterceptor";
import {signOut, useSession} from "next-auth/react";
import {ClientContext} from "../../contexts/ClientContext";
import WebInfo from "../WebInfo";
import TopHeader from "../header/TopHeader";
import Header from "../header/Header";
import CookiesManager from "../CookiesManager";
import ChatWidget from "../chat/ChatWidget";
import AccountMigration from "../AccountMigration";
import InvocaLinked from "../InvocaLinked";
import Footer from "./Footer";

export default function AppLayout(props: any) {
  const router = useRouter()
  const {data: session, status} = useSession();
  const {clientCtx} = useContext(ClientContext)
  const [serverIsDown, setServerIsDown] = useState(false)

  useEffect(() => {
    if (status == "authenticated") {
      request({
        url: `/ch/en/validateAuth`,
        method: 'GET',
        session: session
      }).then(res => {
        if (res.data.forceLogout) {
          signOut({redirect: false}).then(() => window.location.reload())
        }
      })
    }
  }, [session, status, router.asPath, clientCtx]);

  useEffect(() => {
    // This is a health check to see if the server is up
    // If not it will trigger the ErrorBoundary
    request({
      url: `/ch/en/bootstrap`,
      method: 'GET',
    }).catch(() => {
      setServerIsDown(true)
    })
  }, []);

  if (serverIsDown) {
    throw new Error("API is not reachable")
  }

  return (
    <>
      {clientCtx?.webInfoBanners && <WebInfo/>}
      <TopHeader/>
      <Header/>
      {props.children}
      <CookiesManager/>
      <ChatWidget/>
      <AccountMigration/>
      <InvocaLinked/>
      <Footer/>
    </>
  )
}
